export const USER_REQUEST = 'USER_REQUEST'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_ERROR = 'USER_ERROR'
export const USER_ACCOUNT_FORM_DATA = 'USER_ACCOUNT_FORM_DATA'
export const USER_FORGOT_PASSWORD_OTP_TOKEN = 'USER_FORGOT_PASSWORD_OTP_TOKEN'
export const USER_OTP_DATA = 'USER_OTP_DATA'
export const USER_DATA = 'USER_DATA'